import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { setDisplayName } from './hoc-helpers';

function withIntl(WrappedComponent, getIntlFromState) {
	function WithIntl(props) {
		return (
			<WrappedComponent {...props} />
		);
	}

	function mapStateToProps(state) {
		return {
			intl: getIntlFromState(state)
		};
	}

	function mergeProps(stateProps, dispatchProps, ownProps) {
		return {
			...ownProps,
			...stateProps
		};
	}

	setDisplayName(WithIntl, WrappedComponent);

	return connect(mapStateToProps, null, mergeProps)(WithIntl);
}

export const IntlPropType = PropTypes.func.isRequired;

export default withIntl;


// WEBPACK FOOTER //
// ./frontend/shared/react-hocs/intl-hoc.js